import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeMainRoutingModule } from './home-main-routing.module';
import { HomeMainComponent } from './home-main.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { SolutionComponent } from './solution/solution.component';
import { ResidentialComponent } from './solution/residential/residential.component';
import { ErrorComponent } from './solution/residential/404error.component';
import { Error503Component } from './solution/residential/503error.component';
import { Error500Component } from './solution/residential/500error.component';
import { Error400Component } from './solution/residential/400error.component';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterModule } from '@angular/router';
import { HgCommonModule } from '../hg-common/hg-common.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { DepositPendingStatus } from './solution/residential/deposit-pending-status.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { AdminUtilityComponentInfo } from '../admin-utility/admin-utility.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { HgEnergyProvidersUtilityInfoComponent } from '../admin-utility/hg-energy-providers-utility-info/hg-energy-providers-utility-info.component';
import { HgEnergyProvidersTduRatesComponent } from '../admin-utility/hg-energy-providers-tdu-rates/hg-energy-providers-tdu-rates.component';
import { AdminUtilityReportComponent } from '../admin-utility/admin-utility-report/admin-utility-report.component';
import { AdminAffiliationListComponent } from '../admin-utility/admin-affiliation-list/admin-affiliation-list.component';
import { AdminZipcodeListComponent } from '../admin-utility/admin-zipcode-list/admin-zipcode-list.component';
import { AdminPromoCodeListComponent } from '../admin-utility/admin-promocode-list/admin-promocode-list.component';
import {CustomDatePipe} from  '../admin-utility/admin-affiliation-list/admin-affiliation-list.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { LoginModule } from './../login/login.module';
import { HttpClientModule } from '@angular/common/http';
import { CommonHeaderModule } from '../common-header/common-header.module';
import { AdminUtilityPreProvidersComponent } from '../admin-utility/admin-utility-pre-providers/admin-utility-pre-providers.component';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatTooltipModule } from '@angular/material/tooltip'
import {NumericInputDirective} from  '../admin-utility/admin-zipcode/admin-zipcode.component';

@NgModule({
  imports: [
    CommonModule,
    HomeMainRoutingModule,
    BsDropdownModule.forRoot(),
    RouterModule,
    HgCommonModule,
    ScrollToModule.forRoot(),
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    LoginModule,
    HttpClientModule,
    CommonHeaderModule,
    MatSortModule,
        MatCheckboxModule,
        MatTooltipModule
    
  ],
  exports: [HomeMainComponent, FooterComponent],
  declarations: [
    HomeMainComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    SolutionComponent,
    ResidentialComponent,
    ErrorComponent,
    Error503Component,
    Error500Component,
    Error400Component,
    DepositPendingStatus,
    AdminUtilityComponentInfo,
    HgEnergyProvidersUtilityInfoComponent,
    HgEnergyProvidersTduRatesComponent,
    AdminUtilityReportComponent,
    AdminUtilityPreProvidersComponent,
    AdminAffiliationListComponent,
    AdminZipcodeListComponent,
    AdminPromoCodeListComponent,
    CustomDatePipe,
    NumericInputDirective
    
  ],
})
export class HomeMainModule {}
